export default "__VITE_ASSET__BRPpUS8___"